<div class="user-login">
  <andor-section-intro>
    <span>
      {{ 'Sign in to unlock permissions and customize your app experience.' | translate }}
    </span>
  </andor-section-intro>
  <div class="content">
    @if (appService.authenticationState() === 'logged-out') {
      <img
        class="logo"
        src="/assets/icon_sad_{{ userSettingsStore.colorMode$ | async }}.svg"
        alt="" />
      <div class="welcome">{{ 'You are currently not a member of any team.' | translate }}</div>
      <form>
        <andor-text-input
          [control]="password"
          autocomplete="password"
          type="password"
          (actionClicked)="appService.login($event)"
          toolTipMsg="{{
            'The password to join a team and unlock advanced permissions.' | translate
          }}"
          errorMsg="{{
            'Password may not be empty and contains at least 6 characters.' | translate
          }}"
          label="{{ 'Team Password' | translate }}"></andor-text-input>
      </form>
      @if (appService.authenticationError()) {
        <div class="error">
          {{ appService.authenticationError() }}
          <br />
          <span>
            {{
              'Please check your password and your internet connection and try again.' | translate
            }}
          </span>
        </div>
      }
      @if (appService.cooldown.remaining('roleLogin')) {
        <p role="status">
          {{
            'Please wait [seconds] seconds before trying again.'
              | translate: { seconds: appService.cooldown.remaining('roleLogin') }
          }}
        </p>
      }
      <andor-forgot-password></andor-forgot-password>
    }
    @if (!appService.authenticationError() && appService.authenticationState() === 'loading') {
      <span>{{ 'Loading...' | translate }}</span>
    }
    @if (appService.authenticationState() === 'logged-in') {
      <img class="logo" src="/assets/icon_{{ userSettingsStore.colorMode$ | async }}.svg" alt="" />
      <div class="welcome">
        {{ "You're a member of the exclusive team:" | translate }}
        <div class="role">{{ appService.roleName() }}</div>
      </div>
    }
  </div>
  <div class="actions">
    @if (appService.authenticationState() === 'logged-in') {
      <andor-button type="gradient" (click)="appService.logout()">
        <span>{{ 'Leave Team' | translate }}</span>
      </andor-button>
    } @else {
      <andor-button
        type="gradient"
        [disabled]="
          appService.cooldown.remaining('roleLogin') > 0 ||
          appService.authenticationState() === 'loading' ||
          !password.valid
        "
        (click)="appService.login(password.value ?? '')">
        <span>{{ 'Join Team' | translate }}</span>
      </andor-button>
    }
  </div>
</div>
